<template>
  <v-container fluid class="mt-1">
    <validation-observer v-slot="{ valid }">
      <base-material-card
        color="primary"
        icon="mdi-file-table-box-multiple-outline"
        inline
        class="ml-0 px-5 py-4"
        title="Adicionar Grupo de Relatório"
      >
        <v-row class="mt-3">
          <v-col cols="9">
            <validation-provider v-slot="{ errors }" rules="required|max:30">
              <v-text-field
                id="nome-grupo-relatorios"
                v-model="titulo"
                label="Nome"
                outlined
                :error-messages="errors"
                class="ml-4"
              />
            </validation-provider>
          </v-col>
          <v-col cols="3">
            <validation-provider id="exclusivo-grupo-relatorios" v-slot="{ errors }" rules="required">
              <v-select v-model="exclusivo" :items="['Sim', 'Não']" label="Exclusivo" :error-messages="errors" outlined />
            </validation-provider>
          </v-col>
        </v-row>
        <v-row class="mt-n6">
          <v-col cols="12" md="6" class="pt-0" />
          <v-col cols="12" md="6" class="pr-0">
            <v-btn
              id="btn-save-grupos-relatorios"
              class="mr-3"
              color="primary"
              min-width="100"
              style="float: right"
              :loading="loading"
              :disabled="!valid"
              @click="salvar()"
            >
              Salvar
            </v-btn>
          </v-col>
        </v-row>
      </base-material-card>
    </validation-observer>
  </v-container>
</template>

<script>
  import GruposRelatoriosService from '@/services/GruposRelatoriosService';
  import routes from '@/store/modules/routes';

  export default {
    data: () => ({
      titulo: '',
      loading: false,
      exclusivo: 'Não'
    }),

    created() {
      if (this.$route.params.id) this.getGrupo(this.$route.params.id);
    },

    methods: {
      getGrupo(id) {
        GruposRelatoriosService.getGrupoRelatorio(id)
          .then((response) => {
            const rData = response.data.data;
            this.exclusivo = rData.exclusivo ? 'Sim' : 'Não';
            this.titulo = rData.titulo;
          })
          .catch(() =>
            this.$toast.error('Erro ao recuperar grupo de relatório.', '', {
              position: 'topRight'
            })
          );
      },

      salvar() {
        this.loading = true;
        let data = {
          id: this.$route.params.id ? this.$route.params.id : null,
          titulo: this.titulo,
          exclusivo: this.exclusivo == 'Sim' ? true : false
        };

        GruposRelatoriosService.save(data)
          .then(() => {
            this.$toast.success('Grupo de Relatório salvo com sucesso.', '', {
              position: 'topRight'
            });
            this.$router.replace({
              name: routes.state.appRoutes['GRUPOS_RELATORIOS_HISTORICO']
            });
          })
          .catch(() => {
            this.$toast.error('Erro ao salvar grupo de relatório.', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loading = false));
      }
    }
  };
</script>
